import {SpacingSizeRange} from '../../types';

export const customSpacing: SpacingSizeRange = {
  xxs: '0.125rem',
  xs: '0.25rem',
  sm: '0.375rem',
  md: '0.5rem',
  lg: '0.75rem',
  xl: '1rem',
  '2xl': '1.25rem',
  '3xl': '1.5rem',
  '4xl': '2rem',
  '5xl': '2.5rem',
  '6xl': '3rem',
  '7xl': '4rem',
  '8xl': '5rem',
  '9xl': '6rem',
  '10xl': '8rem',
  '11xl': '10rem',
};
